export default "__VITE_ASSET__DrVwP_rj__"